import { Typography } from "@mui/material";
import React from "react";

import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { useTranslation } from "react-i18next";

export type TableCellDueDateProps = {
  data: any;
};

const TableCellDueDate: React.FC<TableCellDueDateProps> = (props) => {
  const { t } = useTranslation();
  const value = props.data.value;

  if (value === null || !value) return <Typography>N/A</Typography>;

  const dueDate = value && new Date(value);
  const now = Date.now();
  const diffTime = dueDate - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 0) {
    return (
      <Typography color="error.main">
        <WarningAmberRoundedIcon fontSize="small" sx={{ verticalAlign: "sub", mr: 0.5 }} />
        {t("common:countDaysAgo", { count: Math.abs(diffDays) })}
      </Typography>
    );
  }

  if (diffDays <= 4) {
    return (
      <Typography color="warning.main">
        <ErrorOutlineOutlinedIcon fontSize="small" sx={{ verticalAlign: "sub", mr: 0.5 }} />
        {t("common:countDays", { count: diffDays })}
      </Typography>
    );
  }

  return <Typography color="text.secondary">{t("common:countDays", { count: diffDays })}</Typography>;
};

export default TableCellDueDate;
